// extracted by mini-css-extract-plugin
export default {"titleBlock":"styles_titleBlock__cQuMZ","title":"styles_title__u0dUU","arrow":"styles_arrow__2zKAX","dropDownBlock":"styles_dropDownBlock__SKWjO"};